import type { Route } from 'next';
import type { HTMLElementType, ReactNode } from 'react';

import { Link } from '#components/Link/Link';

import styles from './ArticleItemTitleLink.module.scss';

type Props = {
	as?: HTMLElementType;
	children: ReactNode;
	path: Route;
	title?: string;
	headingClassName?: string;
	className?: string;
};

export function ArticleItemTitleLink({ as: As = 'h2', children, title, path, headingClassName, className = '' }: Props) {
	return (
		// On request of Audience Analytics team, we have added static className="aitl-gtm" to TitleLink, Info: Please consult Audience Analytics team before making any change.
		<Link className={`aitl-gtm ${styles.titleLink} ${className} underline-hover`} title={title} href={path}>
			<As className={headingClassName}>{children}</As>
		</Link>
	);
}
